export default __webpack_public_path__ + "svgs/rm_logo_black_coop-a55ce8fc.svg";